/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:21:24
 */
export default {
  lang: "英语",
  landing: {
    name1: "Carlcare ਖੋਲ੍ਹੋ",
    name2: "ਰਿਜ਼ਰਵ ਕਰੋ",
    name3: "Carlcare ਨਾਲ ਤੁਸੀਂ ਕਿਸੇ ਵੀ ਵੇਲੇ ਆਪਣੇ ਆਰਡਰ ਚੈੱਕ ਕਰ ਸਕਦੇ ਹੋ।",
    name4: "",
    name5: "ਸੱਜੇ ਪਾਸੇ ਸਲਾਈਡ ਕਰੋ",
    name6: "ਪੁਸ਼ਟੀਕਰਨ ਪੂਰਾ ਹੋ ਗਿਆ",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for out-of-warranty Infinix/Tecno/itel designated models.",
    name11: "Starting from Rp.120K, you can get your battery replaced with no labor fee.",
    name12: 'Click the link to make a reservation or visit designated service centers to enjoy this hassle-free service.', // 小字标注
    name13: "Why Choose Carlcare Flat-Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name16: "Lower and Transparent Pricing",
    name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy worry-free usage with a dependable warranty.",
    name20: "Fast and Easy On-Site Service",
    name21: "Quick and convenient battery replacement done face-to-face.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for out-of-warranty battery replacements only.",
    name27: "3. If you join the flat-price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the right to modify the promotion based on actual circumstances. For inquiries or assistance, please call Carlcare hotline at 02150880282.",
    name31: "Rules",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "From Rp120.000",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
        name40: "Exclusive for",
    name41: "Jakarta Pusat!",
    name42: "Reservation Now",
    name43: "What is Carlcare Home Service ?",
    name44: "1.Carlcare Home Service is available for TECNO, Infinix, and itel users.",
    name45: "2.Enjoy convenient and efficient repair services anywhere (at home, in the office, at a café, on campus, or outdoors), saving you time and effort.",
    name46: "Why do we recommend choosing Carlcare Home Service ?",
    name47: "Free Home Service Charges",
    name48: "No home service fees required.",
    name49: "*For out of warranty or accidental damage, pay for parts and labor.",
    name50: "Easy Booking",
    name51: "Easily book through Carlcare App, website, hotline, or WhatsApp.",
    name52: "Safe & Reliable",
    name53: "With strict safety measures, ensuring your device is in trusted hands.",
    name54: "Official Support",
    name55: "All repairs by Carlcare official engineers use only original spareparts.",
    name56: "Ways to Book Carlcare Home Service",
    name57: "1. Open the Carlcare App",
    name58: '2. Tap "Reservation"',
    name59: '3. Choose "Carlcare Home Service"',
    name60: "4. Select your current location",
    name61: "5. Fill in the required details to complete the reservation",
    name62: "1. Open the Carlcare Official Website:https://www.carlcare.com/id/",
    name63: '2. Tap "Perbaiki Telepon"',
    name64: '3. Choose "Carlcare Home Service"',
    name65: "4. Select your current location",
    name66: "5. Fill in the required details to complete the reservation",
    name67: "Call Carlcare hotline: 021 5088 0282 to book Carlcare Home Service.",
    name68: "Contact Carlcare WhatsApp Business Account:+62-812-9009-0559 to Carlcare Home Service.",
    name69: "1.Device needs repair.",
    name70: "2.Book Carlcare Home Service.",
    name71: "3.Engineer contacts you to confirm the appointment time.",
    name72: "4.Engineer arrives at the scheduled time.",
    name73: "5.Complete the repair and make the payment.",
    name74: "Statement:",
    name75: "1.Free Home Service applies to service fees only. ",
    name76: "①Under Warranty: Enjoy free home service and repairs;",
    name77: "②Out of Warranty:Only pay for labor and spareparts,no extra home service charges.",
    name78: "2.Carlcare Home Service is currently limited to the the Jakarta Pusat and will gradually expand to more regions in the future. Please Stay tuned!",
    name79: "3.The final explanation of the activity belongs to Carlcare.",
    name80: "Carlcare App",
    name81: "Carlcare Website",
    name82: "Carlcare Hotline",
    name83: "Carlcare WhatsApp",
    name84: "No door-to-door fee",
    name85: "Service Process:",
  },
  order: {
    name1: "ਡਿਵਾਈਸ ਮਾਡਲ ਚੁਣੋ",
    name2: "ਨੁਕਸ ਵਰਣਨ:",
    name3: "ਸੇਵਾ ਸਟੋਰ ਚੁਣਨ ਲਈ ਛੂਹੋ",
    name4: "ਸੇਵਾ ਸਟੋਰ:",
    name5: "ਰਿਜ਼ਰਵੇਸ਼ਨ ਦਾ ਸਮਾਂ:",
    name6: "ਆਪਣੇ ਡਿਵਾਈਸ ਦੀ ਸਮੱਸਿਆ ਬਾਰੇ ਵੇਰਵੇ ਨਾਲ ਦੱਸੋ ਜੀ!",
    name7: "ਪਹੁੰਚਣ ਦੇ ਸਮੇਂ ਨੂੰ ਛੂਹੋ",
    name8: "ਆਪਣੇ ਠੀਕ ਸੰਪਰਕ ਵੇਰਵੇ ਦਿਓ ਤਾਂ ਕਿ ਅਸੀਂ ਤੁਹਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰ ਸਕੀਏ",
    name9: "ਮੌਜੂਦਾ ਰਿਜ਼ਰਵੇਸ਼ਨ ਸਮੇਂ ਅੱਗੇ ਦਿੱਤੇ ਹਨ",
    name10: "ਆਪਣੇ ਫੋਨ ਨੰਬਰ ਦਰਜ ਕਰੋ",
    name11: "ਕੀਮਤ",
    name12: "ਨਿੱਜੀ ਜਾਣਕਾਰੀ:",
    name13: "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਨਾਂ ਦਰਜ ਕਰੋ",
    name14: "ਭੇਜੋ",
    name15: "ਰੱਦ ਕਰੋ",
    name16: "ਠੀਕ ਹੈ",
  },
  shops: {
    name1: "ਤੁਹਾਡੇ ਵਲੋਂ ਚੁਣੇ ਬਰੈਡ ਦੇ ਅਧਾਰ ਉੱਤੇ ਅੱਗੇ ਦਿੱਤੇ ਸਤੋਰ ਤੁਹਾਨੂੰ ਸੇਵਾ ਦੇ ਸਕਦੇ ਹਨ!",
    name2: "ਹੋਰ ਰਿਟੇਲ ਸਟੋਰ ਛੇਤੀ ਹੀ ਆ ਰਹੇ ਹਨ! ਸਾਡੇ ਨਾਲ ਜੁੜੇ ਰਹੋ!",
  },
  price: {
    name1: "ਬਰਾਂਡ",
    name2: "ਮਾਡਲ",
    name3: "ਆਈਟਮ",
    name4: "ਕੀਮਤ",
    name5: "ਦੋਸਤਾਨਾ ਤਾਕੀਦ:",
    name6: "ਇਹ ਕੀਮਤਾਂ ਸਿਰਫ਼ ਹਵਾਲੇ ਲਈ ਹਨ ਅਤੇ ਅਸਲ ਕੀਮਤ ਤੁਹਾਡੇ ਡਿਵਾਈਸ ਦੀ ਹਾਲਤ ਉੱਤੇ ਨਿਰਭਰ ਹੈ।",
    name7: "ਜੇ ਕੋਈ ਖਾਸ ਚਿੰਨ੍ਹ ਨਹੀਂ ਹੈ ਤਾਂ ਕੀਮਤ ਦੀ ਇਕਾਈ ਲੋਕਲ ਕਰੰਸੀ ਇਕਾਈ ਹੈ।",
    name8: "ਅਫ਼ਸੋਸ! ਮੌਜੂਦਾ ਖੇਤਰ ‘ਚ ਕੋਈ ਕੀਮਤ ਜਾਣਕਾਰੀ ਉਪਲੱਬਧ ਨਹੀਂ ਹੈ।",
    name11:"ਲੇਬਰ ਦੀ ਲਾਗਤ",
    name12:"ਕੁੱਲ ਕੀਮਤ",
    name13: "5. ਜੇ ਲੇਬਰ ਦੀ ਲਾਗਤ \"/\" ਹੈ, ਤਾਂ ਇਸ ਦਾ ਮਤਲਬ ਇਹ ਹੈ ਕਿ ਲੇਬਰ ਦੀ ਲਾਗਤ ਬਾਰੇ ਸਟੋਰ ਨਾਲ ਸਲਾਹ-ਮਸ਼ਵਰਾ ਕਰਨ ਦੀ ਲੋੜ ਹੈ।",
    item_main_board: "ਮਦਰਬੋਰਡ",
    item_screen_frame: "ਸਕਰੀਨ (ਫ੍ਰੇਮ)",
    item_screen_screen_frame: "ਸੈਕੰਡਰੀ ਸਕਰੀਨ (ਫ੍ਰੇਮ)",
    item_touch_screen: "ਟੱਚ ਸਕਰੀਨ",
    item_camera: "\"ਕੈਮਰਾ\"",
    item_fixed_focus_camera: "ਫਿਕਸਡ ਫੋਕਸ ਕੈਮਰਾ",
    item_auto_focus_camera: "ਆਟੋ ਫੋਕਸ ਕੈਮਰਾ",
    item_screen: "ਸਕਰੀਨ",
    item_secondary_screen: "ਸੈਕੰਡਰੀ ਸਕਰੀਨ",
    item_fingerprint_module: "ਫਿੰਗਰਪ੍ਰਿੰਟ ਮਾਡਿਊਲ",
    item_speaker: "ਸਪੀਕਰ",
    item_receiver: "ਰਿਸੀਵਰ",
    item_small_board: "ਛੋਟਾ ਬੋਰਡ",
    item_battery_cover: "ਬੈਟਰੀ ਕਵਰ",
    item_battery: "ਬੈਟਰੀ",
    item_charger: "ਚਾਰਜਰ",
    item_usb_cable: "USB ਕੇਬਲ",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "ਕੋਈ ਡਾਟਾ",
    name2: "ਸਰਵਿਸ ਪੂਰਕ:",
    name3: "ਸੇਵਾ ਬਰੈਂਡ:",
    name4: "ਟੈਲੀਫ਼ੋਨ:",
    name5: "ਆਰਡਰ ਦੀ ਮਾਤਰਾ:",
    name6: "ਸੇਵਾ ਰੇਟਿੰਗ:",
    name7: "ਸੇਵਾ ਇੰਵਾਇਰਨਮੈਂਟ",
    name8: "ਸੇਵਾ ਵਿਹਾਰ:",
    name9: "ਸੇਵਾ ਕਾਰਗੁਜ਼ਾਰੀ:",
    name10: "ਸੇਵਾ ਦੀ ਕੁਆਲਟੀ:",
    name11: "ਗਾਹਕ ਦਾ ਮੁਲਾਂਕਣ",
    name12:"ਤੋਂ",
    name13:"ਬੰਦ ਕੀਤਾ",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Carlcare ਖੋਲ੍ਹੋ",
    name1: "ਰਿਜ਼ਰਵੇਸ਼ਨ ਦੀ ਜਾਣਕਾਰੀ ਦਾ ਸਕਰੀਨਸ਼ਾਟ ਲਵੋ ਤੇ ਇਸ ਨੂੰ ਤਰਜੀਹੀ ਸੇਵਾ ਲਈ ਪਹੁੰਚ ਵਾਸਤੇ ਰਸੀਦ ਵਜੋਂ ਸੰਭਾਲੋ।",
    name2: "ਕਾਮਯਾਬੀ ਨਾਲ ਭੇਜਿਆ",
    name3: "1. ਡਾਟਾ ਮਿਟਾਓ",
    name4: "ਆਪਣੇ ਫ਼ੋਨ ‘ਤੇ ਖ਼ਾਸ ਪ੍ਰਾਈਵੇਟ ਡਾਟੇ ਦਾ ਬੈਕਅੱਪ ਪਹਿਲਾਂ ਹੀ ਲੈ ਲਵੋ",
    name5: "2. ਸ਼ੁਰੂ ਵੇਲੇ ਦਾ ਪਾਸਵਰਡ ਅਸਮਰੱਥ ਕਰੋ",
    name6: "ਸੇਵਾ ਸਟੋਰ ‘ਤੇ ਜਾਣ ਤੋਂ ਪਹਿਲਾਂ, ਕਿਰਪਾ ਕਰਕੇ:",
    name7: "ਸੇਵਾ ਸਟੋਰ:",
    name8: "ਰਿਜ਼ਰਵੇਸ਼ਨ ਦਾ ਸਮਾਂ:",
    name9: "ਨੁਕਸ ਵਰਣਨ:",
    name10: "ਡਿਵਾਈਸ ਮਾਡਲ:",
    name11: "ਆਰਡਰ ਨੰਬਰ:",
    name12: "ਆਰਡਰ ਦੀ ਜਾਣਕਾਰੀ",
  },
  title: {
    
    name1: "ਅੱਗੇ ਦਿੱਤੇ ਦੇਸ਼ਾਂ ਲਈ ਸਹਇਕ ਹੈ:",
    name2: "ਮਾਡਲ ਚੁਣੋ",
    name3: "ਰਾਖਵਾਂਕਰਨ",
    name4: "ਸੇਵਾ ਸਟੋਰ ਦੇ ਵੇਰਵੇ",
    name5: "ਸੇਵਾ ਸਟੋਰ ਨੂੰ ਚੁਣੋ",
  },
  error: {
    
    name1: "ਕੋਈ ਡਾਟਾ ਨਹੀਂ। ਆਪਣੀ ਰਿਪੇਅਰ ਜਾਣਕਾਰੀ ਦੀ ਜਾਂਚ ਕਰੋ",
    name2: "ਹੋਰ ਮਦਦ ਚਾਹੀਦੀ ਹੈ? ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।",
    name3: "ਅਫਸੋਸ, ਇਸ ਖੇਤਰ ‘ਚ ਕੋਈ Carlcare ਕੇਂਦਰ ਨਹੀਂ ਹੈ।",
    name4: "ਪਹਿਲਾਂ ਸੇਵਾ ਕੇਂਦਰ ਚੁਣੋ ਜੀ",
    name5: "ਅਸਫ਼ਲ ਹੈ",
    name6: "ਪਹਿਲਾਂ ਡਿਵਾਈਸ ਦਾ ਮਾਡਲ ਚੁਣੋ",
    name7: "ਵੇਰਵੇ",
    name8: "ਆਪਣੀਆਂ ਲੋੜਾਂ ਬਾਰੇ ਵੇਰਵੇ ‘ਚ ਵਰਣਨ ਕਰੋ",
    name9: "",
  },
  add1:{
    "name0": "pa-rIN",
    "name1": "ਤੁਹਾਡੇ ਆਰਡਰ ਦੀ ਪੁਸ਼ਟੀ ਹੋ ਗਈ ਹੈ। ਅਸੀਂ ਤੁਹਾਡੇ ਪਹੁੰਚਣ ਦੀ ਉਡੀਕ ਕਰ ਰਹੇ ਹਾਂ।",
    "name2": "ਸ਼ਹਿਰ ਚੁਣੋ",
    "name3": "ਕਿਰਪਾ ਕਰਕੇ %1$s ਅੰਕਾਂ ਦਾ ਫ਼ੋਨ ਨੰਬਰ ਦਰਜ ਕਰੋ।",
    "name4": "ਹਫ਼ਤੇ ਦੇ ਦਿਨ ਦੇ ਘੰਟੇ",
    "name5": "ਸੋਮਵਾਰ",
    "name6": "ਮੰਗਲਵਾਰ",
    "name7": "ਬੁੱਧਵਾਰ",
    "name8": "ਵੀਰਵਾਰ",
    "name9": "ਸ਼ੁੱਕਰਵਾਰ",
    "name10": "ਸ਼ਨਿਚਰਵਾਰ",
    "name11": "ਐਤਵਾਰ",
    "name12": "ਦੇਸ਼ ਦਾ ਨਾਮ ਦਰਜ ਕਰੋ ਅਤੇ ਖੋਜੋ"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "ਹੋਰ",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"ਰੀਡਾਇਰੈਕਟ ਕਰਨ ਲਈ ਟੈਪ ਕਰੋ",
    name3:"ਆਰਡਰ ਨੂੰ ਰੇਟ ਕਰਨ ਲਈ Carlcare ਐਪ ਨੂੰ ਖੋਲ੍ਹੋ",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"ਸੇਵਾ ਚੁਣੋ",
    name7:"ਮੁਫ਼ਤ ਸਫਾਈ",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "ਗਲਤ ਜਾਣਕਾਰੀ",
    "cancelReason1": "ਸਮੇਂ ਸਿਰ ਨਹੀਂ ਪਹੁੰਚ ਸਕਦੇ",
    "cancelReason2": "ਡੁਪਲੀਕੇਟ ਆਰਡਰ/ਮੇਰਾ ਆਰਡਰ ਨਹੀਂ ਹੈ",
    "cancelReason3": "ਅਸਫਲਤਾ ਦੁਬਾਰਾ ਨਹੀਂ ਆਈ",
    "cancelReason4": "ਸਿਰਫ਼ ਟੈਸਟ/ਪੁੱਛਗਿੱਛ/ਇਵੈਂਟ/…",
    "cancelReason5": "ਉੱਚ ਕੀਮਤ",
    "cancelReason6": "ਸਮਾਨ ਦੀ ਕਮੀ",
    "cancelReason7": "ਕੋਈ ਵੱਖਰੀਆਂ ਸੇਵਾਵਾਂ ਨਹੀਂ ਹਨ",
    "cancelReason8": "ਸਟੋਰ ਬਹੁਤ ਦੂਰ ਹੈ",
    "cancelReason9": "ਸਟੋਰ ਬੰਦ ਹੈ",
    "cancelReason10": "ਸਰਵਿਸ ਵਾਲਿਆਂ ਦਾ ਮਾੜਾ ਰਵੱਈਆ",
    "cancelReason11": "ਹੋਰ ਬ੍ਰਾਂਡਾਂ ਲਈ ਰਿਪਲੇਸਮੈਂਟ/ਮੁਰੰਮਤ",
    "cancelReason12": "ਸਟੋਰ ਨਹੀਂ ਲੱਭਿਆ",
    "cancelReason13": "ਹੋਰ",
    "cancelOrder": "ਆਰਡਰ ਰੱਦ ਕਰੋ",
    "reason_dialog_title": "ਕਿਰਪਾ ਕਰਕੇ ਸਾਨੂੰ ਰੱਦ ਕਰਨ ਦਾ ਕਾਰਨ ਦੱਸੋ",
    "Cancel": "ਰੱਦ ਕਰੋ",
    "OK": "ਠੀਕ",
    "name1": "ਤਸਦੀਕ ਕੋਡ ਦਰਜ ਕਰੋ",
    "name2": "ਤਸਦੀਕ ਕੋਡ ਅਵੈਧ ਹੈ",
    "repair_reservation_detail_canceled": "ਇਹ ਆਰਡਰ ਰੱਦ ਕੀਤਾ ਜਾ ਚੁੱਕਾ ਹੈ!",
    "purchase_cancel_dialog_content": "ਕੀ ਤੁਸੀਂ ਆਰਡਰ ਰੱਦ ਕਰਨ ਦੀ ਪੁਸ਼ਟੀ ਕਰਦੇ ਹੋ?",
    "yes": "ਹਾਂ",
    "no": "ਨਹੀਂ"
}
};
